import { Injectable } from '@angular/core';
import { LocalStorageService } from '@ui-app/services/local-storage.service';
import { CustomModalService } from '@ui-app/services/custom-modal.service';
import { AppToastrService } from '@ui-app/services/toastr.service';
import {UserProfileService} from '@ui-app/services/user-profile.service';
import {UserRoleService} from '@ui-app/services/user-role.service';
import { InfoModalComponent } from '@ui-app/modals/info-modal/info-modal.component';

@Injectable({
    providedIn: 'root'
})
export class EmployeeBusinessService {
  
    

    constructor(
        public userProfileService: UserProfileService,
        public userRoleService: UserRoleService,
        public localStorageService: LocalStorageService,
        public customModalService: CustomModalService,
        public toasterService: AppToastrService,
        public infoModalService: CustomModalService
    ) {
    }
}
